import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Isvg from 'react-inlinesvg';
import BLUETOOTH_STATUS from 'constants/bluetooth';
import { isChromecastDeviceAvailable } from 'helpers/interactive';
export var DeviceSetupCast =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DeviceSetupCast, _React$Component);

  function DeviceSetupCast(props) {
    var _this;

    _classCallCheck(this, DeviceSetupCast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DeviceSetupCast).call(this, props));
    _this.handleBrowserPlay = _this.handleBrowserPlay.bind(_assertThisInitialized(_this));
    _this.handleCastClick = _this.handleCastClick.bind(_assertThisInitialized(_this));
    _this.handleConnectionChange = _this.handleConnectionChange.bind(_assertThisInitialized(_this));
    _this.renderTop = _this.renderTop.bind(_assertThisInitialized(_this));
    _this.renderBody = _this.renderBody.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DeviceSetupCast, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (global.cast && global.cast.framework) {
        var castContext = global.cast.framework.CastContext.getInstance();
        castContext.removeEventListener(global.cast.framework.CastContextEventType.CAST_STATE_CHANGED, this.handleConnectionChange);
      }
    }
  }, {
    key: "handleConnectionChange",
    value: function handleConnectionChange(state) {
      var onToggleHide = this.props.onToggleHide;

      if (state.castState === global.cast.framework.CastState.CONNECTING) {
        onToggleHide(false);
      }
    }
  }, {
    key: "handleCastClick",
    value: function handleCastClick() {
      var _this$props = this.props,
          alias = _this$props.alias,
          localJoinClass = _this$props.joinClass,
          hideModal = _this$props.hideModal,
          status = _this$props.status,
          updateDevice = _this$props.updateDevice;

      if (global.cast && global.cast.framework) {
        var castContext = global.cast.framework.CastContext.getInstance();
        castContext.addEventListener(global.cast.framework.CastContextEventType.CAST_STATE_CHANGED, this.handleConnectionChange);
        updateDevice({
          status: BLUETOOTH_STATUS.ATTEMPTING_TO_CAST
        });
        castContext.requestSession().then(function () {
          hideModal('DeviceSetupModal');
          localJoinClass(alias);
        }).catch(function (e) {
          if (status === BLUETOOTH_STATUS.ATTEMPTING_TO_CAST || e === 'session_error') {
            hideModal('DeviceSetupModal');
          }
        });
      }
    }
  }, {
    key: "handleBrowserPlay",
    value: function handleBrowserPlay() {
      var _this$props2 = this.props,
          alias = _this$props2.alias,
          localJoinClass = _this$props2.joinClass,
          hideModal = _this$props2.hideModal;
      localJoinClass(alias);
      global.BitmovinPlayer.play('ui');
      hideModal('DeviceSetupModal');
    }
  }, {
    key: "renderTop",
    value: function renderTop(availableCastDevices) {
      var status = this.props.status;

      if (status === BLUETOOTH_STATUS.ATTEMPTING_TO_CAST) {
        return React.createElement("div", {
          className: "modal__device-setup__top"
        }, React.createElement("h3", null, React.createElement(FormattedMessage, {
          id: "device.casting-header",
          defaultMessage: "Casting to TV"
        })));
      }

      return availableCastDevices ? React.createElement("div", {
        className: "modal__device-setup__top"
      }, React.createElement("h3", null, React.createElement(FormattedMessage, {
        id: "device.cast-header",
        defaultMessage: "Cast this class to your TV"
      })), React.createElement(FormattedMessage, {
        id: "device.header-p",
        defaultMessage: "Click the button below to cast this class to your TV. Be sure to select the correct input on your TV.",
        tagName: "p"
      })) : React.createElement("div", {
        className: "modal__device-setup__top"
      }, React.createElement("h3", null, React.createElement(FormattedMessage, {
        id: "device.no-devices-header",
        defaultMessage: "No Chromecast devices found"
      })), React.createElement(FormattedMessage, {
        id: "device.no-devices-p",
        defaultMessage: "We couldn't find any Chromecast devices on your network. Make sure Wi-Fi is on and your Chromecast is connected to the same network.",
        tagName: "p"
      }));
    }
  }, {
    key: "renderBody",
    value: function renderBody(availableCastDevices) {
      var status = this.props.status;

      if (status === BLUETOOTH_STATUS.ATTEMPTING_TO_CAST) {
        return React.createElement("div", {
          className: "modal__device-setup__content"
        }, React.createElement("div", null, React.createElement("img", {
          src: require('../../../static/img/icon/chromecast/casting.gif'),
          alt: "Cast"
        }), React.createElement("p", {
          className: "mt-"
        }, React.createElement(FormattedMessage, {
          id: "device.watch.on-tv",
          defaultMessage: "Casting to your TV..."
        }))));
      }

      return React.createElement("div", {
        className: "modal__device-setup__content"
      }, React.createElement("button", {
        className: classNames('bt bt--primary bt--width-md modal__device-cast__bt', {
          'modal__device-cast__bt--disabled': !availableCastDevices
        }),
        onClick: this.handleCastClick
      }, React.createElement(Isvg, {
        src: require('../../../static/img/icon/chromecast/chromecast-empty.svg'),
        className: "modal__device-cast__cast-logo mr-"
      }), React.createElement("span", {
        className: "modal__device-cast__cast-text"
      }, "Cast to TV")), React.createElement("p", {
        className: "modal__device-cast__reminder mv"
      }, React.createElement(FormattedMessage, {
        id: "device.or",
        defaultMessage: "or"
      })), React.createElement("button", {
        className: "bt bt--oultine bt--mkt-white bt--width-md mb",
        onClick: this.handleBrowserPlay
      }, React.createElement(FormattedMessage, {
        id: "device.watch.browser",
        defaultMessage: "Watch in browser"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var availableCastDevices = isChromecastDeviceAvailable();
      return React.createElement("div", {
        className: "modal__device-cast"
      }, this.renderTop(availableCastDevices), this.renderBody(availableCastDevices));
    }
  }]);

  return DeviceSetupCast;
}(React.Component);
DeviceSetupCast.propTypes = {
  alias: PropTypes.string,
  hideModal: PropTypes.func,
  joinClass: PropTypes.func,
  onToggleHide: PropTypes.func,
  status: PropTypes.string,
  updateDevice: PropTypes.func
};